import { get } from "lodash";

export class StageEHealthDeclaration {
    radio_1: string;
    radio_2: string;
    radio_3: string;

    input_1: string;
    input_2: string;
    input_3: string;

    constructor(initial?: any) {
        this.radio_1 = get(initial, "radio_1", "");
        this.radio_2 = get(initial, "radio_2", "");
        this.radio_3 = get(initial, "radio_3", "");

        this.input_1 = get(initial, "input_1", "");
        this.input_2 = get(initial, "input_2", "");
        this.input_3 = get(initial, "input_3", "");
    }
}

export class Step3FormData {
    hpsCoverageForLoginUser: string;
    hpsRequired: boolean;
    isLoginUserZeroCoverage: boolean;

    constructor(initial?: any) {
        this.hpsCoverageForLoginUser = get(initial, "shareCover", "");
        this.hpsRequired = get(initial, "hpsRequired", "");
        this.isLoginUserZeroCoverage = get(initial, "isLoginUserZeroCoverage", "");
    }
}